// extracted by mini-css-extract-plugin
module.exports = {"container":"Apple_container__ncHj9","desktop":"Apple_desktop__2H1JJ","AppWindowContainer":"Apple_AppWindowContainer__268kU","dock":"Apple_dock__2ITXK"};